import {BaseModel, DisableModel} from 'model/base.model';

export interface Contract extends BaseModel, DisableModel {
  id?: number | string;
  docTemplateId?: string;
}

export const defaultContract: Readonly<Contract> = {
};
